import { TransportItem, TransportItemFull, TransportType } from '../bus/transport/types';
import $axios from '../utils/axios-instance';

export default class TransportApi {
  async getTransportList() {
    return await $axios
      .get<{ data: TransportItem[] }>('/v1/Transport')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getTransportContractor(data: { id: number | string }) {
    return await $axios
      .get<TransportItemFull>(`/v1/Transport/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getTransportDetail(data: { id: number | string }) {
    return await $axios
      .get<TransportItemFull>(`/v1/Transport/${data.id}/details`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createTransport(data: Omit<TransportItem, 'id'>) {
    return await $axios
      .post('/v1/Transport', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeTransport(data: TransportItem) {
    return await $axios
      .put(`/v1/Transport/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteTransport(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/Transport/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getTransportTypes() {
    return await $axios
      .get<TransportType[]>('/v1/Transport/types')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
